import { render, staticRenderFns } from "./CopyStakeGamesForAutoclickerTab.vue?vue&type=template&id=54162c6c&scoped=true&lang=pug"
import script from "./CopyStakeGamesForAutoclickerTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeGamesForAutoclickerTab.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeGamesForAutoclickerTab.vue?vue&type=style&index=0&id=54162c6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54162c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDataTable,VIcon,VRow})
